import React from 'react';
import BasicContent from "../../svgs/basic-content.svg"
import ContentComparisonTool from "../../svgs/content-comparison.svg"
import WalmartSearchBoost from "../../svgs/walmart-search-boost.svg"
import ContentTrends from "../../svgs/content-trends.svg"
import RichMedia from "../../svgs/rich-media.svg"
import InvaderAlert from "../../svgs/invader-alert.svg"
import TopShopperQuestions from "../../svgs/top-shopper-questions.svg"
import ShopperSentimentAnalysis from "../../svgs/shopper-sentiment-analysis.svg"
import ShareOfVoice from "../../svgs/share-of-voice.svg"
import PrioritizedKeywordList from "../../svgs/prioritized-keyword-list.svg"
import ItemSearchScorecard from "../../svgs/search-scorecard.svg"
import SearchSnapshot from "../../svgs/search-snapshot.svg"
import ShareOfDigitalShelf from "../../svgs/share-of-digital-shelf.svg"
import TrafficReports from "../../svgs/traffic-reports.svg"
import WinSearch from "../../svgs/win-search.svg"
// import ChartLine from "../../svgs/chart-line-solid.svg"
// import WalmartSearch from "../../svgs/walmart-search-boost.svg"
// import SearchDollar from "../../svgs/search-dollar-solid.svg"
import SearchSensei from "../../svgs/search-sensei.svg"
import AdSensei from "../../svgs/ad-sensei.svg"
import DedicatedSupport from "../../svgs/dedicated-support.svg"
import DigitalCatalog from "../../svgs/digital-catalog.svg"
import SKUie from "../../svgs/SKUie.svg"
// import SellerSuite from "../../svgs/seller-suite.svg"
import ManagedServices from "../../svgs/user-tie-solid.svg"

export const BeltsPlansPricesList = [
    // {
    //     title:['Content Center', <br/>, '(Yellow Belt)'],
    //     icon: <BasicContent/>,
    //     hex:'#efc621',
    //     color:'yellow',
    //     listPrice:'$5/item/month',
    //     sku:'ybs',
    //     description:'Simplified content management and publishing support for Walmart.com listings.',
    //     tools:['Basic Content CMS', 'Content Comparison Tool'],
    //     toolIcons:[
    //         <BasicContent/>,
    //         <ContentComparisonTool/>
    //     ],
    //     tooltips:[
    //         "Make changes to your item pages' title, description, key features, images, and attributes from your online SKU Ninja dashboard.",
    //         "Easily audit the content of your catalog of items: See what's live on Walmart.com, compare it to what's in SKU Ninja, and see changes!"
    //     ],
    //     price:5,
    //     isMonthlyRecurring:true, 
    //     makePricePublic:true,
    //     numOfItems: 0,
    //     contactUs: false
    // },
    // {
    //     title:['Get Found', <br/>, '(Green Belt)'],
    //     icon: <ContentTrends/>,
    //     hex:'#1eca8a',
    //     color:'green',
    //     listPrice:'$35/item/month',
    //     sku:'gbs',
    //     description:'Tools to ensure items show up in search, monitor page stats, and host enhanced content.',
    //     tools:['Walmart Search Boost', 'Content Trends', 'Unlimited Enhanced Content'],
    //     toolIcons:[
    //         <WalmartSearchBoost/>,
    //         <ContentTrends/>,
    //         <RichMedia/>
    //     ],
    //     tooltips:[
    //         "Audit and improve your pages' Content Quality Scores to optimize them for Walmart.com search.",
    //         "Get updates on your item-level content & more. Monitor your pages for dropped content and keep tabs on your competitors!",
    //         "Host every type of enhanced content in SKU Ninja on your Green Belt items: product videos, feature sets, and more!"
    //     ],
    //     price:35,
    //     isMonthlyRecurring:true, 
    //     makePricePublic:true,
    //     numOfItems: 0,
    //     contactUs: false
    // },
    // {
    //     title:['Insights', <br/>, '(Purple Belt)'],
    //     icon: <TrafficReports/>,
    //     hex:'#7c8bdf',
    //     color:'purple',
    //     listPrice:'$35/item/month',
    //     sku:'pbs',
    //     description:'Deep insights on your shoppers and buy box to shape your ecommerce strategy.',
    //     tools:['Invader Alert', 'Top Shopper Questions', 'Shopper Sentiment Analysis'],
    //     toolIcons:[
    //         <InvaderAlert/>,
    //         <TopShopperQuestions/>,
    //         <ShopperSentimentAnalysis/>
    //     ],
    //     tooltips:[
    //         "Track the Buy Box on your item pages to find new listings of your items added by a third party, with valuable metrics on how you can take action.",
    //         "Get a list of questions most commonly asked by shoppers about items like yours. Improve your content and SEO by providing the answers.",
    //         "See the words that show up in reviews for your product type, analyzed by AI to guide your SEO, content, and strategy."
    //     ],
    //     price:35,
    //     isMonthlyRecurring:true, 
    //     makePricePublic:true,
    //     numOfItems: 0,
    //     contactUs: false
    // },
    // {
    //     title:['Win Search', <br/>, '(Blue Belt)'],
    //     icon: <WinSearch/>,
    //     hex:'#00aeef',
    //     color:'blue',
    //     listPrice:'$35/item/month',
    //     sku:'bbs',
    //     description:'Proprietary tools to monitor and improve your search rank on Walmart.com.',
    //     tools:['Share of Voice', 'Prioritized Keyword List', 'Item Search Scorecard', 'Search Snapshot', 'Share of Digital Shelf'],
    //     toolIcons:[
    //         <ShareOfVoice/>,
    //         <PrioritizedKeywordList/>,
    //         <ItemSearchScorecard/>,
    //         <SearchSnapshot/>,
    //         <ShareOfDigitalShelf/>
    //     ],
    //     tooltips:[
    //         "Convert your category’s search results into a single digestible metric. Identify keyword-item combinations where you can win in search.",
    //         "Get a list of SEO keywords for your item descriptions & marketing content, prioritized by volume and relevance.",
    //         "Identify what brands are winning the top keywords for your category, and see which keywords are being bought by your competitors.",
    //         "Quickly see an item’s search rank for every keyword. Get an item’s average, best, and worst search rank over a 14-day period.",
    //         "Visual readout of the unique items making up the search results for the top keywords in your category, assembled by brand and by seller."
    //     ],
    //     price:35,
    //     isMonthlyRecurring:true, 
    //     makePricePublic:true,
    //     numOfItems: 0,
    //     contactUs: false
    // },
    {
        title:['SKU Ninja'],
        icon: <SKUie/>,
        listPrice:'$99/item/month',
        sku:'snelt',
        description:"Unlimited access to all of SKU Ninja's tools for Walmart.com and Walmart OPD.",
        tools:['Content Center', 'Get Found', 'Insights', 'Win Search', 'Enhanced Content Hosting'],
        toolIcons:[
            <BasicContent/>,
            <ContentTrends/>,
            <TrafficReports/>,
            <WinSearch/>,
            <RichMedia />
        ],
        tooltips:[
            "Simplified content management and publishing support for Walmart.com listings.",
            "Tools to ensure items show up in search, monitor page stats, and host enhanced content.",
            "Deep insights on your shoppers and buy box to shape your ecommerce strategy.",
            "Proprietary tools to monitor and improve your search rank on Walmart.com.",
            "Easily add videos, A+ content, and more to your Walmart.com pages with SKU Ninja's rich media creator."
        ],
        price:99,
        isMonthlyRecurring:true, 
        makePricePublic:true,
        numOfItems: 0,
        contactUs: false
    },
    // {
    //     title:['Seller Suite'],
    //     icon: <SellerSuite/>,
    //     hex:'#C19A6B',
    //     color:'brown',
    //     listPrice:'',
    //     sku:'',
    //     description:"Unlock Success on Walmart Marketplace",
    //     tools:['Content', 'Insight & Analytics', 'Ad Management'],
    //     toolIcons:[
    //         <WalmartSearch/>,
    //         <ChartLine/>,
    //         <SearchDollar/>
    //     ],
    //     price: 0,
    //     isMonthlyRecurring:true, 
    //     makePricePublic:true,
    //     numOfItems: 0,
    //     contactUs: true
    // },
    // {
    //     title:['Managed Services', <br/>, '(Black Belt)'],
    //     icon: <ManagedServices/>,
    //     hex:'#000000',
    //     color:'black',
    //     listPrice:'',
    //     sku:'',
    //     description:"Managed solutions to take your items to the next level",
    //     tools:['Search Sensei', 'Ad Sensei', 'Dedicated Support', 'Digital Catalog Program'],
    //     toolIcons:[
    //         <SearchSensei/>,
    //         <AdSensei/>,
    //         <DedicatedSupport/>,
    //         <DigitalCatalog />
    //     ],
    //     tooltips:[
    //         "Engage our team of experts to do a deep dive on your portfolio and dominate search results.",
    //         "Earn incremental traffic and sales with ad campaign strategies executed by the Ad Sensei team.",
    //         "Dedicated human resources to manage your catalog of items on Walmart.com.",
    //         "An all-inclusive program to establish and manage digital catalog excellence on Walmart.com"
    //     ],
    //     price: 0,
    //     isMonthlyRecurring:true, 
    //     makePricePublic:true,
    //     numOfItems: 0,
    //     contactUs: true
    // }
]